module.exports = __webpack_public_path__ + "index/img/icon_anquan.20920d40.svg";